module.exports = __webpack_public_path__ + "img/mission-diversity-refugees.jpg?2d5cef22802cbe1fd25fd1a49038de10";